import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ChatRepository} from "@dropDesk/domain/repositories/chat/chat.repository";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";

@injectable()
export class GetUsersFromCacheUseCase {
    private _repository: ChatRepository;

    constructor(@inject(ChatRepository) repository: ChatRepository) {
        this._repository = repository;
    }

    public call(ids: string[]): Promise<UserEntity[]> {
        return this._repository.getUsersFromCache(ids);
    }
}
